<h1 mat-dialog-title class="text-dark text-xl">
  {{ data.id ? 'Modifica Servizio pratica' : 'Nuovo Servizio pratica' }}
</h1>
<div mat-dialog-content class="w-full">
  <app-service-practice-form [data]="data"></app-service-practice-form>
</div>
